import { createSelector } from 'reselect';

const loginSelector = createSelector(
  (state) => state.login,
  (login) => login,
);

export const isTokenSent = createSelector(
  loginSelector,
  (login) => login.isTokenSent,
);

export const isTokenInvalid = createSelector(
  loginSelector, (login) => login.isTokenInvalid,
);

export default loginSelector;
